import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { AzureSqlCopySource } from 'app/model/pipeline/copysource/azure-sql.copysource';
import { SqlCopySourceAdapter, sqlSourceAdapts } from './sql.copysource.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureSqlCopySource),
    asynchronous: true,
    adapts: sqlSourceAdapts
})
export class AzureSqlCopySourceAdapter extends SqlCopySourceAdapter {}
